import { Credentials, findCredential } from "../../constants/credentials";
import "./CredentialBadge.css";

export function CredentialBadge({ event, inline = false, iconSize = 20, showLabel = false }) {
	function getCredentialTypeIcon(credentialType) {
		const IconComp = Credentials[credentialType]?.icon ?? Credentials.desconhecido.icon;
		return <IconComp size={iconSize ?? 20} />
	}

	function getCredentialTypeName(credentialType) {
		return Credentials[credentialType]?.description ?? Credentials.desconhecido.description;
	}

	if (inline) {
		return (
			<>
				{findCredential(event) && (
					<span className="inline-flex gap-1.5 items-center">
						{getCredentialTypeIcon(findCredential(event))}
						{getCredentialTypeName(findCredential(event))}
					</span>
				)}
			</>
		);
	}

	return (
		<>
			{findCredential(event) && (
				<span className={`credential-type ${event?.result !== '1' && event?.result !== 'Falha' ? '' : 'credential-denied'}`}>
					{getCredentialTypeIcon(findCredential(event))}
					{showLabel && getCredentialTypeName(findCredential(event))}
				</span>
			)}
		</>
	)
}